module.exports = __webpack_public_path__ + "static/img/1_11_2.3e0a9db6.jpg";